export const SAVE_EMPLOYEE = 'SAVE_EMPLOYEE';
export const SAVE_EMPLOYEE_SUCCESS = 'SAVE_EMPLOYEE_SUCCESS';
export const SAVE_EMPLOYEE_FAILURE = 'SAVE_EMPLOYEE_FAILURE';
export const ADD_EMPLOYEE_TO_THE_LIST = 'ADD_EMPLOYEE_TO_THE_LIST';
export const UPDATE_EMPLOYEE_IN_THE_LIST = 'UPDATE_EMPLOYEE_IN_THE_LIST';



// WEBPACK FOOTER //
// ./src/modules/EmployeeForm/actionTypes.js